
import { Component, Vue, Watch } from "vue-property-decorator";
import { User } from "./api/dtos/User.schema";
import { UsersModule } from "./store/modules/UsersModule";
import ThemeToggle from "@/components/ThemeToggle.vue";

@Component({
  components: {
    ThemeToggle,
  },
})
export default class extends Vue {
  drawer: boolean | null = null;

  mounted() {
    // Set initial state based on screen size
    this.drawer = this.$vuetify.breakpoint.lgAndUp;

    // Load saved theme preference
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      this.$vuetify.theme.dark = savedTheme === "dark";
    }
  }

  @Watch("$vuetify.breakpoint.mdAndDown")
  onMediumAndDownBreakpointChange(isMdAndDown: boolean) {
    if (isMdAndDown) {
      this.drawer = false;
    } else {
      this.drawer = true;
    }
  }

  closeDrawerOnMobile(): void {
    // Close drawer on tablet and mobile when navigating
    if (this.$vuetify.breakpoint.mdAndDown) {
      this.drawer = false;
    }
  }

  logoutUser(): void {
    UsersModule.logout();
  }

  get localUser(): User | null {
    return UsersModule.localUser;
  }
}
